export default {
  data() {
    return {
      visible: true,
    };
  },
  computed: {
    choices() {
      return [...this.flashcard.answers].sort((a, b) => a.sortOrder - b.sortOrder);
    },
    flashcardTemplate() {
      let template = this.flashcard.question;
      if( !this.answered ) {
        this.flashcard.question.match(/\{\{[^\}]+\}\}/g).forEach( (match) => {
          const identifier = match.replace(/[\{\}\s]/g, '');
          const m = RegExp(`\{\{ *${identifier} *\}\}`);
          template = template.replace(m, `<span id="container-${identifier}"></span>`);
        });
      } else {
        this.flashcard.question.match(/\{\{[^\}]+\}\}/g).forEach( (match) => {
          const identifier = match.replace(/[\{\}\s]/g, '');
          const m = RegExp(`\{\{ *${identifier} *\}\}`);
          template = template.replace(m, `<span id="container-${identifier}"></span>`);
        });
      }
      return template;
    },
  },
  watch: {
    async $route(to, from) {
      // this are about to get a little weird
      this.visible = false;
      await this.$nextTick();
      this.visible = true;
      await this.$nextTick();
      this.arrangeChoices();
    },
  },
  mounted() {
    this.$nextTick(this.arrangeChoices);
  },
  methods: {
    arrangeChoices() {
      for (let i = 0; i < this.choices.length; i++) {
        const displayOrder = i + 1;
        const highlightIdentifier = `highlight-${displayOrder}`;
        const containerIdentifier = `container-${highlightIdentifier}`;

        const highlightElement = document.getElementById(highlightIdentifier);
        const containerElement = document.getElementById(containerIdentifier);

        if( highlightElement && containerElement ) {
          if( highlightElement.parentNode !== containerElement ) {
            containerElement.appendChild(highlightElement);
          }
        }
      }
    },
    handleChoiceClick(item) {
      if( this.answered ) {
        return;
      }
      item.selected = !item.selected;
      const selectedChoices = this.flashcard.answers.filter( c => c.selected );
      const selectedChoiceIds = selectedChoices.map( c => c.id );
      if( selectedChoiceIds.length > 0 ) {
        this.$emit('set-answer-ids', selectedChoiceIds);
      } else {
        this.$emit('set-answer-ids', []);
      }
      this.$forceUpdate();
    },
    choiceIdentifier(id) {
      return `highlight-${id}`;
    },
  },
};
